<template>
  <div class="z-card">
    <h4>{{ $t('mailer.mailing.form.block.sender.title') }}</h4>
    <div class="z-card__body">
      <z-form-group class="row mb-0">
        <div class="col-3 text-right">
          {{ $t('mailer.mailing.form.field.sender.title') }}
        </div>
        <z-form-input class="col-9" :rules="{ required: true }">
          <i-select :value="current_sender" @on-change="set_value">
            <i-option
              v-for="sender in senders"
              :key="sender.id"
              :value="sender.name"
              :label="sender.name"
            />
          </i-select>
        </z-form-input>
      </z-form-group>
    </div>
  </div>
</template>

<script>
  import { SenderService } from '@mailer/services/SenderService';

  export default {
    data() {
      return {
        senders: [],
        current_sender: null
      };
    },

    created() {
      SenderService.getSelect().then(
        (response) => (this.senders = response?.filter(f => f.status === 'active'))
      );
    },

    methods: {
      set_value: function(sender_name) {
        const current_sender = this.senders.find(f => f.name === sender_name);
        this.current_sender = current_sender.name;
        this.$emit('input', current_sender);
      }
    }
  };
</script>
